import ExternalRegisterPage from './ExternalRegisterPage';

const COLUMNS = [
  ['Registration Number', 'registration_number'],
  ['Product Name', 'product_name'],
  ['Active Substance', 'werkzamestoffen'],
  ['ATC', 'atc'],
  ['Pharmaceutical Form', 'pharmaceutical_form'],
  ['Strength', 'potentie'],
  ['Administration Route', 'administration_route'],
  ['MA Holder', 'marketing_authorisation_holder'],
  ['Registration Status', 'registration_status'],
  ['Registration Date', 'registration_date'],
  ['Withdrawal Date', 'withdrawal_date'],
  ['Procedure Type', 'procedure_type'],
  ['Legal Status', 'legal_status'],
];

const DATE_COLS = new Set(['registration_date', 'withdrawal_date']);

const FILTER_CONFIGS = [
  { key: 'regSearch', label: 'Registration Number', type: 'search', column: 'registration_number', placeholder: 'Search by RVG/EU number...' },
  { key: 'prodName', label: 'Product Name', column: 'product_name' },
  { key: 'activeSub', label: 'Active Substance', column: 'werkzamestoffen' },
  { key: 'legalStatus', label: 'Legal Status', column: 'legal_status' },
  // Gear-hidden
  { key: 'soort', label: 'Soort', column: 'soort' },
  { key: 'inschrijving', label: 'Inschrijvingsdatum', column: 'inschrijvingsdatum' },
  { key: 'pharmaForm', label: 'Pharmaceutical Form', column: 'pharmaceutical_form' },
  { key: 'potentie', label: 'Strength (Potentie)', column: 'potentie' },
  { key: 'adminRoute', label: 'Administration Route', column: 'administration_route' },
  { key: 'atcCode', label: 'ATC Code', column: 'atc_code' },
  { key: 'hulpstoffen', label: 'Auxiliary Substances (Hulpstoffen)', column: 'hulpstoffen' },
  { key: 'maHolder', label: 'MA Holder', column: 'marketing_authorisation_holder' },
  { key: 'regStatus', label: 'Registration Status', column: 'registration_status' },
  { key: 'procType', label: 'Procedure Type', column: 'procedure_type' },
  { key: 'procNum', label: 'Procedure Number', column: 'procedurenummer' },
  { key: 'addMon', label: 'Additional Monitoring', column: 'aanvullendemonitoring' },
  { key: 'regDate', label: 'Registration Date', column: 'registration_date' },
  { key: 'withdrawDate', label: 'Withdrawal Date', column: 'withdrawal_date' },
];

const DEFAULT_FILTERS = ['regSearch', 'prodName', 'activeSub', 'legalStatus'];

const DETAIL_SECTIONS = [
  {
    title: 'Identification',
    fields: [
      { key: 'registration_number', label: 'Registration Number' },
      { key: 'product_name', label: 'Product Name' },
      { key: 'soort', label: 'Soort' },
      { key: 'atc', label: 'ATC' },
    ],
  },
  {
    title: 'Composition',
    fields: [
      { key: 'werkzamestoffen', label: 'Werkzamestoffen', wide: true },
      { key: 'hulpstoffen', label: 'Hulpstoffen', wide: true },
    ],
  },
  {
    title: 'Dosage',
    fields: [
      { key: 'pharmaceutical_form', label: 'Farmaceutische Vorm' },
      { key: 'potentie', label: 'Potentie' },
    ],
  },
  {
    title: 'Authorisation',
    fields: [
      { key: 'marketing_authorisation_holder', label: 'MA Holder' },
      { key: 'registration_status', label: 'Registration Status' },
      { key: 'legal_status', label: 'Legal Status' },
      { key: 'procedure_type', label: 'Procedure Type' },
      { key: 'procedurenummer', label: 'Procedure Number' },
      { key: 'registration_date', label: 'Registration Date' },
      { key: 'withdrawal_date', label: 'Withdrawal Date' },
      { key: 'inschrijvingsdatum', label: 'Inschrijvingsdatum' },
      { key: 'aanvullendemonitoring', label: 'Additional Monitoring' },
    ],
  },
  {
    title: 'Documents',
    fields: [
      { key: 'smpc_filenaam', label: 'SmPC' },
      { key: 'bijsluiter_filenaam', label: 'Bijsluiter' },
      { key: 'par_filenaam', label: 'PAR' },
      { key: 'spar_filenaam', label: 'SPAR' },
      { key: 'armm_filenaam', label: 'ARMM' },
      { key: 'smpc_wijzig_datum', label: 'SmPC Wijzig Datum' },
      { key: 'bijsluiter_wijzig_datum', label: 'Bijsluiter Wijzig Datum' },
    ],
  },
  {
    title: 'References',
    fields: [
      { key: 'productdetail_link', label: 'Product Detail Link', wide: true },
      { key: 'nieuws_links', label: 'Nieuws Links', wide: true },
      { key: 'nieuws_link_datums', label: 'Nieuws Link Datums' },
      { key: 'referentie', label: 'Referentie' },
      { key: 'smpc_vorige_versie', label: 'SmPC Vorige Versie' },
      { key: 'smpc_vorige_vorige_versie', label: 'SmPC Vorige Vorige Versie' },
    ],
  },
];

export default function DutchSupps() {
  return (
    <ExternalRegisterPage
      source="dutch"
      title="Dutch Medicines Register (CBG-MEB)"
      breadcrumb="Dutch CBG-MEB"
      sourceUrl="https://www.geneesmiddeleninformatiebank.nl/"
      columns={COLUMNS}
      dateColumns={DATE_COLS}
      defaultFilterKeys={DEFAULT_FILTERS}
      filterConfigs={FILTER_CONFIGS}
      prefsKey="dutchFilters"
      detailTitle="Dutch CBG-MEB Record Details"
      detailSections={DETAIL_SECTIONS}
    />
  );
}
